import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {Icon} from 'front-onceforall-core';
import {Tooltip} from '@material-ui/core';
import authenticationService from '../../../../../services/authentication/AuthenticationService';

function AddButtonView(props) {
  const isBackOffice = authenticationService.roles().isBackOffice();
  const isManager = authenticationService.roles().isManager();

  if (!isBackOffice && !isManager) {
    return null;
  }

  const getButton = disabled => (
    <span>
      <button
        type="button"
        className={'large inline-container ' + (isManager && props.hasUserSlotsLeft ? 'cta' : 'bo')} // eslint-disable-line
        onClick={props.onClick} // eslint-disable-line
        disabled={disabled}
        style={disabled ? {pointerEvents: 'none'} : {}}
      >
        <Icon icon="plus"/>
        <Translate value="user.add"/>
      </button>
    </span>
  );

  if (!props.hasSubscription) {
    return (
      <Tooltip title={<Translate value="user.missingSubscription"/>}>
        {getButton(true)}
      </Tooltip>);
  }

  if (isBackOffice || (isManager && props.hasUserSlotsLeft)) {
    return getButton(false);
  }

  if (isManager && !props.hasUserSlotsLeft) {
    return (
      <Tooltip title={<Translate value="user.maxUsersReached"/>}>
        {getButton(true)}
      </Tooltip>);
  }
}

AddButtonView.propTypes = {
  hasSubscription: PropTypes.bool.isRequired,
  hasUserSlotsLeft: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

export default AddButtonView;
